import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import ModalForm from "./ModalForm.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchSaveModal',
    props: {
        searchRequest: {}
    },
    setup(__props) {
        const props = __props;
        const form = {
            name: 'search',
            fields: [
                {
                    name: 'name',
                    label: 'Name',
                    type: 'text',
                    options: {
                        required: true,
                        maxLength: 50,
                    },
                }
            ],
        };
        const data = ref({
            name: '',
        });
        if (props.searchRequest.query) {
            data.value.name = props.searchRequest.query;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalForm, {
                form: form,
                data: data.value,
                "modal-size": "small",
                title: _ctx.$t('search.filters_save'),
                "submit-label": _ctx.$t('save'),
                "submit-icon": "save",
                onSubmit: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('save', data.value.name))),
                onCancel: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
            }, null, 8, ["data", "title", "submit-label"]));
        };
    }
});
